module.exports = __webpack_public_path__ + "img/Group_5.06cd907e.png";